module.exports = __webpack_public_path__ + "static/media/next.da74aded.svg";